<template>
  <div class="container-narrow my-4">
    <h1 class="title has-text-left">CSCS Card Types</h1>
    <div class="has-text-left mb-4">
      Here are the CSCS Cards you can apply for. Please note that you are
      required to hold the relevant qualification or equivalant qualification
      for applying a CSCS Card. The requirements can be found in <b>Know More</b> for each card.
    </div>
    <hr>
    <div class="columns">
      <div v-for="cardTypeId in [0, 1, 2]" :key="cardTypeId" class="column">
        <CardBox :card-type-id="cardTypeId" />
      </div>
    </div>

    <div class="columns mt-2">
       <div v-for="cardTypeId in [3, 4, 5]" :key="cardTypeId" class="column">
        <CardBox :card-type-id="cardTypeId" />
      </div>
    </div>

    <div class="columns mt-2">
      <div v-for="cardTypeId in [6, 7, 8]" :key="cardTypeId" class="column">
        <CardBox :card-type-id="cardTypeId" />
      </div>
    </div>

    <div class="columns mt-2">
      <div v-for="cardTypeId in [9, 10]" :key="cardTypeId" class="column">
        <CardBox :card-type-id="cardTypeId" />
      </div>
      <div class="column"></div>
    </div>
      <hr/>
    <div class="columns mt-2">
      <div class="column has-text-left">
        <h2 class="has-text-weight-bold is-size-6 has-text-left">
          Book Your CITB Health, Safety &amp;
          Environment Test required to apply for a CSCS Card.
          <router-link to="/citb-test">More Information here. </router-link>
        </h2>
        <p class="mt-1">
          The CITB Health, Safety &amp; Environment Test (also known
          as a CITB Touch Screen Test),
          is required for a CSCS Card(New/Renew).
          The price of a CITB HS&amp;E Test is £22.50.
          <br>
          <router-link to="/test-per-occupation">Not Sure which test to take?</router-link>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import CardBox from '@/components/CardBox.vue';

export default {
  components: {
    CardBox,
  },
};
</script>
